import { useState, useEffect } from 'react';

export default function useQuoteModal() {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedColor, setSelectedColor] = useState(0);

    // Phone numbers (puedes mover esto a un archivo de configuración)
    const phoneNumbers = [
        { number: "3338217408", display: "(33) 3821 7408" },
        { number: "3318715068", display: "(33) 1871 5068" },
    ];

    // Open quote modal for a specific product
    const openQuoteModal = (product) => {
        setSelectedProduct(product);
        document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
    };

    // Close quote modal
    const closeQuoteModal = () => {
        setSelectedProduct(null);
        document.body.style.overflow = "unset"; // Re-enable scrolling
    };

    // Close modal when pressing Escape key
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape" && selectedProduct) {
                closeQuoteModal();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [selectedProduct]);

    // Generate WhatsApp URL
    const getWhatsAppUrl = (productName) => {
        const message = `Hola, estoy interesado en cotizar el producto: ${productName}`;
        return `https://wa.me/52${phoneNumbers[0].number}?text=${encodeURIComponent(message)}`;
    };

    return {
        selectedProduct,
        selectedColor,
        setSelectedColor,
        openQuoteModal,
        closeQuoteModal,
        phoneNumbers,
        getWhatsAppUrl
    };
}